<template>
    <div class="main">
        <div class="body-content">
            <div class="controls">
                <div class="search-container">
                    <input v-model="searchQuery" placeholder="Search..." />
                    <i class="fas fa-search search-icon"></i>
                </div>
                <h1 class="title">VCN Party Voyage</h1>
                <div class="actions">
                    <div class="tooltip-container" @mouseleave="hideTooltip">
                        <button class="add-button" @click="addElimentModal" title="Add VCN Party Voyage" >
                            <i class="fas fa-plus"></i>
                            <div v-if="showAddTooltip" class="tooltip">Add VCN Party Voyage</div>
                        </button>
                    </div>
                </div>
            </div>
            <div class="table-container">
                <table class="transaction-table table-design">
                    <thead>
                        <tr>
                            <th>
                                <span>Sl. No</span>
                            </th>
                            <th>
                                <span>VCN</span>
                            </th>
                            <th>
                                <span>Vessel</span>
                            </th>
                            <th>
                                <span>Import Voyage</span>
                            </th>
                            <th>
                                <span>Export Voyage</span>
                            </th>
                            <th>
                                <span>Applicant</span>
                            </th>
                            <th>
                                <span>Account</span>
                            </th>
                            <th>
                                <span>Action</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in vcnpartylinklists" :key="index">
                            <td>
                                <span>{{ index + 1 }}</span>
                            </td>
                            <td>
                                <span> {{ item.vcnName }}</span>
                            </td>
                            <td>
                                <span> {{ item.vessel }}</span>
                            </td>
                            <td>
                                <span> {{ item.impv }}</span>
                            </td>
                            <td>
                                <span> {{ item.expv }}</span>
                            </td>
                            <td>
                                <span> {{ item.applicantname }}</span>
                            </td>
                            <td>
                                <span> {{ item.accountname }}</span>
                            </td>
                            <th>
                                <button @click="editElimentModal(item)" class="edit-button"><i
                                        class="fas fa-edit"></i></button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="isModalVisible" class="edit-overlay">
            <div class="edit-overlay-content">
                <span class="close-btn" @click="closeModal">&times;</span>
                <h2><label class="text-h6">{{ isEditing ? 'Edit VCN Party Voyage' : 'Add VCN Party Voyage' }}</label></h2>
                <div class="form-row">
                    <label for="vessel">Vessel:</label>
                    <v-select v-model="record.vcnID" :clearable="false" :options="vcnvoymarge" label="vcndtl"
                        :reduce="vessel => vessel.vcnID" placeholder="Select Vessel" selectOnTab="True"
                        class="field-width" />
                </div>
                <div class="form-row">
                    <label for="applicant">Applicant:</label>
                    <v-select v-model="record.applicant" :options="applicants" label="applicantname" :clearable="false"
                        :reduce="applicants => applicants.applicantid" placeholder="Select Applicant" selectOnTab="True"
                        class="field-width" />
                </div>
                <div class="form-row">
                    <label for="account">Account:</label>
                    <v-select v-model="record.account" :options="accounts" label="accountname" :clearable="false"
                        :reduce="accounts => accounts.accountid" placeholder="Select Account" selectOnTab="True"
                        class="field-width" />
                </div>
                <div class="form-row">
                    <label for="voyage">Import Voyage:</label>
                    <v-select v-model="record.import_voyage" :clearable="false" :options="voyage" label="Name"
                        :reduce="voyage => voyage.Voyageid" placeholder="Select Voyage" selectOnTab="True"
                        class="field-width" />
                </div>
                <div class="form-row">
                    <label for="voyage">Export Voyage:</label>
                    <v-select v-model="record.export_voyage" :clearable="false" :options="voyage" label="Name"
                        :reduce="voyage => voyage.Voyageid" placeholder="Select Voyage" selectOnTab="True"
                        class="field-width" />
                </div>
                <!-- Save and Cancel buttons -->
                <div class="form-buttons">
                    <button type="submit" @click="save" class="save-button">Save</button>
                    <button type="button" class="cancel-button" @click="isModalVisible = false">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
export default {
    components: {
        VSelect,
    },
    data() {
        return {
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            isModalVisible: false, // Control visibility of the modal
            DEFAULT_RECORD: { autoid: 0, vcnID: 0, import_voyage: 0, export_voyage: 0, applicant: 0, account: 0 },
            vcnpartylinklists: [],
            vcnvoymarge: [],
            isEditing: false,
            record: {},
        }
    },
    created() {
        this.fetchvcnpartylinklists();
        this.fetchvcnparty();
    },
    methods: {
        async fetchvcnparty() {
            const token = localStorage.getItem('access_token');
            if (!token) {
                return;
            }
            try {
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };

                const response = await axios.get('/active_vcn_list_marge', config);
                var data = response.data[2]
                data.push({ vcnID: 0, vcndtl: 'Select One' }) 
                this.vcnvoymarge = data;
            } catch (error) {
                console.error('Error fetching component list:', error);
            }
        },
        async fetchvcnpartylinklists() {
            const token = localStorage.getItem('access_token');
            if (!token) {
                return;
            }
            try {
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };

                const response = await axios.get('/vcn_party_link_list', config);
                this.vcnpartylinklists = response.data[2];
            } catch (error) {
                console.error('Error fetching component list:', error);
            }
        },
        async save() {
            const token = localStorage.getItem('access_token');
            if (!token) {
                return;
            }
            try {
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const data = new FormData();
                const transdt = JSON.stringify(this.record)
                console.log(this.record)
                console.log(transdt)
                data.append('transaction', transdt)
                const response = await axios.post('/save_vcnpartylink', data, config);
                if (response.data[0] === 0) {
                    if (this.isEditing) {
                        useToast().error('Error updating VCN Party Voyage');
                    } else {
                        useToast().error('Error adding VCN Party Voyage');
                    }
                } else if (response.data[0] === 1) {
                    if (this.isEditing) {
                        useToast().success('VCN Party Voyage updated successfully');
                        this.isModalVisible = false
                    } else {
                        useToast().success('VCN Party Voyage added successfully');
                    } 
                    this.fetchvcnpartylinklists();
                }

            } catch (error) {
                console.error('Error fetching component list:', error);
            }
        },
        addElimentModal() {
            this.isModalVisible = true; // Show the modal
            this.isEditing = false; // Set to add mode
            this.record = { ...this.DEFAULT_RECORD }; // Reset the record to default
        },
        editElimentModal(item) {
            this.isModalVisible = true; // Show the modal
            this.isEditing = true; // Set editing mode
            console.log('Editing item:', item);
            this.record = {
                autoid: item.autoid,
                applicant: item.applicant,
                account: item.account,
                vcnID: item.vcnID,
                import_voyage: item.import_voyage,
                export_voyage: item.export_voyage
            }; // Set the record to the selected item
        },
        closeModal() {
            this.isModalVisible = false; // Hide the modal
        },
    }
}
</script>
<style scoped>
.field-width {
    width: 450px;
}

.save-button,
.cancel-button {
    font-size: 18px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    color: white;
}

.save-button {
    background-color: #28a745;
}

.cancel-button {
    background-color: red;
}

.table-container {
    /*max-height: 100%;*/
    overflow: auto;
    border: 1px solid #ddd;
    border-radius: 10px;
}

.transaction-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
}

.transaction-table th,
.transaction-table td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.transaction-table th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.transaction-table th .filter-icon {
    cursor: pointer;
    margin-left: 5px;
}

.upload-content-tile h1 {
    color: #343a40;
    font-size: 28px;
    margin-bottom: 25px;
    margin-left: 25px;
}

.form-row {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.form-row label {
    font-weight: bold;
    margin-right: 10px;
    width: 200px;
    /* Adjust width as needed */
    color: #495057;
}

select,
v-select {
    width: 150px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.custom-file-input {
    width: 100%;
    max-width: 300px;
    /* Adjust the width to match the select box */
    padding: 8px;
    border: 2px solid #ced4da;
    border-radius: 8px;
    font-size: 16px;
    color: #495057;
    background-color: #fff;
}

.form-actions {
    margin-top: 30px;
}

.form-actions button {
    padding: 12px 25px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 18px;
    transition: background-color 0.3s ease;
}

.form-actions button:hover {
    background-color: #0056b3;
}

/* Overlay container */
.edit-overlay {
    position: fixed;
    /* Ensures the overlay stays above all other content */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    /* Enables scrolling if the content exceeds viewport height */
    z-index: 9999;
    /* Ensures it appears above all other content */
}

/* Overlay content */
.edit-overlay-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 60%;
    /* Adjusted width for better fit */
    /*max-width: 1000px;*/
    /* Adjusted max-width */
    max-height: 90vh;
    /* Limits the height to prevent overflow */
    overflow-y: auto;
    /* Enables vertical scrolling within the content */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-top: 50px;
    /* Adds margin from the top */
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
    color: #333;
}
</style>